import React from 'react'

const Footer = () => {
  return (
    <>
       {/*Footer Start */}
       <footer className='mt-5 bg-dark text-white p-3 text-center'>
            &copy; 2025 All Rights Resrved. Design and Developed by iLander
        </footer>
    </>
  )
}

export default Footer
